import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Avatar from "@/components/common/Avatar";
import Button from "@/components/common/Button";
import WebIcon from "@/components/common/Web_Icons";

const SingleChat = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");

  const chatData = {
    user: {
      name: "Nusaiba Sabiu",
      status: "Online",
      avatar: null,
    },
    messages: [
      {
        id: 1,
        text: "Can I get my phone number linked with my account on the platform?",
        timestamp: "10 Mins Ago",
        sender: "user",
      },
      {
        id: 2,
        text: "Yes. You can do this via the account section. I can help you set tha up if you give me your profile information.",
        timestamp: "10 Mins Ago",
        sender: "support",
        seen: true,
      },
    ],
  };

  const handleSendMessage = () => {
    if (message.trim()) {
      setMessage("");
    }
  };

  return (
    <div className="flex flex-col h-screen">
      {/* Header */}
      {/* Header */}
      <div className="flex items-center justify-between p-4">
        {/* Back button */}
        <button onClick={() => navigate(-1)} className="flex items-center">
          <WebIcon icon="ArrowLeft" className="w-5 h-5" />
          <span className="text-black text-small">BACK</span>
        </button>

        {/* Right side controls */}
        <div className="flex items-center gap-6">
          <button className="flex items-center">
            <span className="text-black text-small">NEXT</span>
            <WebIcon icon="ArrowRight" className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* User Info */}
      <div className="flex items-center gap-4 p-4 ">
        <Avatar src={chatData.user.avatar} alt={chatData.user.name} size={48} />
        <div className="flex-grow">
          <h2 className="font-medium heading-medium text-primary whitespace-nowrap">
            {chatData.user.name}
          </h2>
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-green"></span>
            <span className="text-gray-600 text-small">
              {chatData.user.status}
            </span>
          </div>
        </div>
        <Button
          text="CLOSE"
          icon={<WebIcon icon="DocumentCode" size="large" />}
          iconPosition="left"
          customBgColor="white"
          customTextColor="primary"
          className="h-10 px-4 py-2 text-small"
          rounded="lg"
          fontWeight="normal border border-primary"
        />
      </div>

      {/* Chat Messages */}
      <div className="flex-1 p-4 space-y-4 overflow-y-auto">
        {chatData.messages.map((msg) => (
          <div
            key={msg.id}
            className={`flex flex-col w-full ${
              msg.sender === "user" ? "items-start" : "items-end"
            }`}>
            {/* Message Box */}
            <div
              className={`max-w-[80%] p-3 rounded-lg ${
                msg.sender === "user"
                  ? "bg-secondary text-black" // Received message (left side)
                  : "bg-primary text-white" // Sent message (right side)
              }`}>
              <p className="text-regular">{msg.text}</p>
            </div>

            {/* Timestamp and Seen Status */}
            <div
              className={`w-[80%] mt-1 ${
                msg.sender === "user"
                  ? "flex items-center gap-2"
                  : "flex items-center justify-end gap-2" // Changed to justify-end for sent messages
              }`}>
              <div className="flex items-center gap-2">
                <WebIcon icon="Clock" className="w-4 h-4 text-lighterGrey" />
                <span className="text-small text-lighterGrey">
                  {msg.timestamp}
                </span>
              </div>

              {msg.seen && msg.sender !== "user" && (
                <div className="flex items-center gap-1 ml-2">
                  <div className="flex items-center justify-center w-4 h-4 rounded-full bg-primary">
                    <svg
                      width="10"
                      height="8"
                      viewBox="0 0 10 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M1 4L3.5 6.5L9 1"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span className="text-small text-lighterGrey">Seen</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Message Input */}
      <div className="p-4 border-t">
        <div className="flex items-center gap-2 p-3 rounded-lg bg-secondary">
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your message..."
            className="flex-1 bg-transparent outline-none text-regular"
          />
          <Button
            icon={<WebIcon icon="Send2" className="w-5 h-5" />}
            className="!p-2 !bg-transparent hover:!bg-gray-200"
            onClick={handleSendMessage}
          />
        </div>
      </div>
    </div>
  );
};

export default SingleChat;
